import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { TreatmentPlan } from "@customTypes/consultation";
import { Pagination } from "@customTypes/index";

import { consultationQKeys } from "./queryKeys";


const select = (res: any) => {
  // console.log(res.data);
  const pagination: Pagination = {
    page: res.data.pagination.page,
    pageCount: res.data.pagination.page_count,
    pageSize: res.data.pagination.page_size,
    total: res.data.pagination.total,
  };

  if (res.data.data.length) {
    const newData: TreatmentPlan[] = [];
    for (const i in res.data.data) {
      const {
        _id,
        aid,
        service,
        quantity,
        consultation_id,
        date,
        created_at,
        updated_at,
        files,
      } = res.data.data[i];

      newData.push({
        id: _id,
        treatment: {
          label: service?.name,
          value: service?._id,
        },
        quantity,
        consultationId: consultation_id,
        supportStaff: {
          value: aid?._id,
          label: aid?.full_name,
        },
        date: new Date(date),
        createdAt: new Date(created_at),
        updatedAt: new Date(updated_at),
        files,
      });
    }

    // newData.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());
    // console.log(newData);
    return {
      newData,
      pagination,
    };
  }
  return null;
};

interface QueryProps {
  patientId: string;
  isEnabled?: boolean;
  pagination?: Partial<Pagination>;
  consultationId?: string;
}

export const useGetTreatmentPlans = ({
  patientId,
  pagination,
  consultationId,
  isEnabled = true,
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: consultationQKeys.treatmentPlanWithFilters(patientId, {
      pagination,
      ...(consultationId && { consultationId }),
    }),
    queryFn: () => {
      return api.get(`treatments/${patientId}`, {
        params: {
          ...(consultationId && { consultation_id: consultationId }),
          ...(pagination && {
            page: pagination.page,
            page_size: pagination.pageSize,
          }),
        },
      });
    },
    select,
    enabled: isEnabled,

    onError: (res: any) => {
      console.error("[From Get Consultation Treatment Plans]", res);
      handleErrors(res, "query");
    },
  });
};
